const stringify = object =>
  JSON.stringify(object, (_, value) => {
    switch (value.constructor) {
      case Object:
        return Object.entries(value)
          .sort()
          .reduce((output, [key, value]) => ({ ...output, [key]: value }), {});
      case Array:
        return value.sort();
      default:
        return value;
    }
  });

const hasTargetingChanged = ({ targeting: first }, { targeting: second }) =>
  stringify(first) !== stringify(second);

export default hasTargetingChanged;
